import { UserLoginServiceProxy, MasterlinkUserServiceProxy } from '@/service-proxies/app-v2/user.service-proxies'
import dayjs from 'dayjs'
import moment from 'moment'
import { Component, Vue } from 'vue-property-decorator'
import * as _ from 'lodash'
import { downloadFile } from '@/utils'
import { loginLogExport } from '@/api/api'

const ulsp = new UserLoginServiceProxy()
const MasterlinkUserService = new MasterlinkUserServiceProxy()
let timeout
let currentValue

@Component
export default class Alarm extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_user_management_login_account') || '登录账户',
        dataIndex: 'account',
        key: 'account',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_transport_directory_account_number'),
        dataIndex: 'userName',
        key: 'userName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_transport_directory_operation_time'),
        dataIndex: 'operationTime',
        width: 300,
        key: 'operationTime',
        ellipsis: true,
        customRender: (item) => {
          return dayjs(item).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: this.$t('page_transport_directory_operation_content'),
        dataIndex: 'operation',
        ellipsis: true,
        key: 'operation'
      }
    ]
  };

  data = []
  startTime = undefined
  endTime = undefined
  dateFormat = 'YYYY-MM-DD'
  height = 500
  current = 1
  size = 30
  total = 0
  loading = false
  userList = []
  userId: any = ''
  lastFetchId = 0
  fetching = false

  created() {
    this.startTime = dayjs().subtract(6, 'day').valueOf()
    this.endTime = dayjs().valueOf()
    this.data = []
    this.search()
  }

  updated() {
    const div = document.body.clientHeight
    this.height = (div - 260)
  }

  onChange(date) {
    if (date && date.length > 0) {
      this.startTime = dayjs(date[0]).valueOf()
      this.endTime = dayjs(date[1]).valueOf()
    } else {
      this.startTime = undefined
      this.endTime = undefined
    }
  }

  get handleSearch() {
    return _.debounce(this.getUserList, 800)
  }

  async getUserList(value) {
    this.lastFetchId += 1
    const fetchId = this.lastFetchId
    this.fetching = true
    const res = await MasterlinkUserService.page(1, undefined, value, -1)
    if (fetchId !== this.lastFetchId) {
      this.fetching = false
      return
    }
    this.userList = res.data.records
  }

  search() {
    this.current = 1
    this.size = 30
    this.total = 0
    this.getData()
  }

  getData() {
    if (this.startTime === undefined || this.endTime === undefined) {
      return
    }
    const startTime = dayjs(this.startTime).format('YYYY-MM-DD')
    const endTime = dayjs(this.endTime).format('YYYY-MM-DD')
    const data: any = {
      query: {
        current: this.current + '',
        size: this.size + ''
      },
      startDate: startTime,
      endDate: endTime,
      userId: this.userId
    }
    this.loading = true
    ulsp.page(data).then(res => {
      this.data = this.addKey(res.data.records)
      this.total = Number(res.data.total)
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  }

  async output() {
    const startTime = this.startTime ? dayjs(this.startTime).format('YYYY-MM-DD') : ''
    const endTime = this.endTime ? dayjs(this.endTime).format('YYYY-MM-DD') : ''
    const data: any = {
      query: {
        current: this.current + '',
        size: -1 + ''
      },
      startDate: startTime,
      endDate: endTime,
      userId: this.userId
    }
    let res = await loginLogExport(data)
    let name = this.$t('page_login_log') + '.xlsx'
    downloadFile(res, name)
  }

  addKey(item) {
    if (item && item.length > 0) {
      item.forEach((res, index) => {
        res.key = index
      })
    }
    return item
  }

  showTotal(total) {
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  handleTableChange(current: number, pageSize: number) {
    this.size = pageSize,
      this.current = current
    this.getData()
  }

  changeUser(e) {
    this.userId = e
  }

  render() {
    return (
      <blank-view>
        <div slot={'action'} style="display:flex;justify-content: space-between">
          <div>
            <span
              style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">{this.$t('page_time_analysis_range')} ：</span>
            <a-range-picker defaultValue={[moment(this.startTime), moment(this.endTime)]} allow-clear={false}
                            style="margin-left:8px; width: 300px" onChange={(date) => this.onChange(date)}/>
            <span
              style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold;margin-left: 8px">
              {this.$t('page_platform_operation_log_search_tip')} ：
            </span>
            <a-select
              show-search
              v-model={this.userId}
              placeholder={this.$t('page_platform_operation_log_search_tip')}
              style="width: 200px;"
              default-active-first-option={false}
              filter-option={false}
              not-found-content={this.fetching ? undefined : null}
              onSearch={this.handleSearch}
              // onChange={(e) => this.changeUser(e)}
              allow-clear={true}
            >
              {this.userList.map(user => (
                <a-select-option key={user.id}>
                  {user.account}
                </a-select-option>
              ))}
            </a-select>
          </div>
          <div>
            <a-button type="primary" style="margin-right: 8px"
                      onClick={() => this.search()}>{this.$t('page_product_search')}</a-button>
            <a-button type="primary"
                      onClick={this.output}>{this.$t('page_ops_work_record_export')}</a-button>
          </div>
        </div>
        <div id="inner" style="height:100%">
          <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            loading={this.loading}
            bordered
            scroll={{ y: this.height }}
          >
          </ml-table>
          <a-pagination
            style="position:absolute;bottom: 4px;right: 20px"
            show-total={total => `${this.showTotal(total)}`}
            current={this.current}
            pageSize={this.size}
            total={this.total}
            on-change={this.handleTableChange}
            on-showSizeChange={this.handleTableChange}
          />
        </div>
      </blank-view>
    )
  }
}
